import Tooltip from "../../components/Tooltip.jsx";
import {CrmProviderChip} from "./CrmVisuals.jsx";
import {formatCrmDate, integrationPresentationLabel, integrationPresentationState, integrationTypeLabel} from "./projectCrmPresentation.js";

export default function CrmIntegrationBadge({integration, projectDeleted = false, t, locale}) {
    const state = integrationPresentationState(integration);
    const stateLabel = integrationPresentationLabel(state, t);
    const providerLabel = integrationTypeLabel(integration.type, t, integration.name);
    const createdAt = formatCrmDate(integration.createdAt, locale);
    const removedAt = formatCrmDate(integration.removedAt, locale);

    return <Tooltip
        bg="dark"
        size="md"
        position="bottom"
        className="inline-flex"
        trigger={<span className="inline-flex" title={`${providerLabel}: ${stateLabel}`}><CrmProviderChip state={state} label={providerLabel}/><span className="sr-only">{stateLabel}</span></span>}
    >
        <div className="space-y-1 text-xs">
            <div className="font-semibold">{providerLabel}</div>
            <div>{t(projectDeleted ? "admin.project_crm.integration_state_at_deletion" : "admin.project_crm.integration_status", {defaultValue: projectDeleted ? "Poslední zachycený stav při smazání projektu" : "Stav integrace"})}: {stateLabel}</div>
            {state === "current" && <div>{t("admin.project_crm.integration_status_basis", {defaultValue: "Stav připojení ověřuje autorizaci, ne běh synchronizace."})}</div>}
            {createdAt && <div>{t("admin.project_crm.created_at", {defaultValue: "Vytvořeno"})}: {createdAt}</div>}
            {removedAt && <div>{t("admin.project_crm.disconnected_at", {defaultValue: "Odpojeno"})}: {removedAt}</div>}
        </div>
    </Tooltip>;
}
